import dayjs, { type Dayjs } from 'dayjs'
import { type TFunction } from 'i18next'

export function dateToText(date: Dayjs, t: TFunction): string {
  const now = dayjs()
  const diff = now.diff(date, 'seconds')
  const minutesAgo = Math.round(diff / 60)
  let result = date.format('DD-MM-YYYY HH:mm:ss')

  if (diff < 5) {
    result = t('pullToRefresh.justNow')
  } else if (diff < 60) {
    result = t('pullToRefresh.secondsAgo', { seconds: diff })
  } else if (minutesAgo === 1) {
    result = t('pullToRefresh.minuteAgo')
  } else if (minutesAgo < 10) {
    result = t('pullToRefresh.minutesAgo', { minutes: minutesAgo })
  }
  return result
}
